import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { BrowserHistoryReplace } from '../../shared/routing/BrowserHistoryReplace';

import { Navbar as ProcessNavbar } from './components/Navbar';

import { Process } from './index';

export const PipelineRoute = (
    <Route
        path="/process"
        render={({ match }) => (
            <React.Fragment>
                <Route component={ProcessNavbar} />
                <Switch>
                    <Route path={`${match.url}/:processName`} render={() => <Process />} />
                    <Route render={() => <BrowserHistoryReplace to={`${match.url}/sales`} />} />
                </Switch>
            </React.Fragment>
        )}
    />
);
